<div (click)="openDialog()">
  <ng-content></ng-content>
</div>
